import { FC, useState } from 'react'

import { useToaster } from '@forto-dev/phoenix-ui-core'

import { RequiredActionV2 } from '@/features/workbench'
import { useLocalisation } from '@/utils/localisation'

import { useShipmentInformationUpdate } from '../../api/useShipmentInformationUpdate'
import { IncoTermsCode } from '../../domain/inco'
import { IncotermSelector } from '../details/incotermSelector'

type ActionIncotermSelectorProps = {
  action: RequiredActionV2
  setSubmitCallback: (cb: (() => Promise<void>) | undefined) => void
}

export const ActionIncotermSelector: FC<ActionIncotermSelectorProps> = ({ action, setSubmitCallback }) => {
  const { translate } = useLocalisation()
  const [incoterm, setIncoterm] = useState<IncoTermsCode>()
  const updateMutation = useShipmentInformationUpdate()
  const toaster = useToaster()

  const updateIncoterm = async (selectedIncoterm: IncoTermsCode) => {
    try {
      await updateMutation.mutateAsync({
        shipmentId: action.entityId,
        data: {
          incoTerms: selectedIncoterm,
        },
      })
      toaster({
        title: translate('required-actions.dialog.incotermUpdateSuccess'),
        variant: 'positive',
      })
    } catch (error) {
      toaster({
        title: translate('required-actions.dialog.incotermUpdateError'),
        description: error instanceof Error ? error.message : translate('errorDescription'),
        variant: 'negative',
      })
    }
  }
  return (
    <>
      <IncotermSelector
        value={incoterm}
        setValue={(newIncoterm) => {
          setIncoterm(newIncoterm)
          setSubmitCallback(async () => await updateIncoterm(newIncoterm))
        }}
        errors={null}
        required
      />
    </>
  )
}
